@if (isMobile()) {
  <div class="mobile-nav">
    @if (!hideNavButton()) {
      <button class="burger"
              aria-label="Toggle navigation menu"
              [ngClass]="{'active':navBarService.isNavBarVisible()}"
              (click)="toggleNavBar()">
        <span class="burger-line"></span>
      </button>
    }
    @if (navigation().title) {
      <h2 class="page-title">{{ navigation().title }}</h2>
    }
  </div>
}
@if (navigation()) {
  <nav class="nav" [ngClass]="{'visible':navBarService.isNavBarVisible()}">
    <ng-content select=".top"></ng-content>
    @if (navigation().title && !isMobile()) {
      <h2 class="page-title">{{ navigation().title }}</h2>
    }
    @if (navigation().items) {
      <ul class="nav-list">
        @for (item of navigation().items; track item.id) {
          <li class="nav-item" (click)="closeMenu()">
            @if (item.path) {
              <a
                [routerLink]="item.path"
                [routerLinkActive]="'current'"
                [routerLinkActiveOptions]="{exact:navigation().isStaticNav ? true : false}"
                class="nav-link"
              >
                <span class="arrow"></span>
                <span>{{ item.title }}</span>
              </a>
            } @else {
              <button
                (click)="onClick(item)"
                class="nav-link"
              >
                <span class="arrow"></span>
                <span>{{ item.title }}</span>
              </button>
            }
          </li>
        }
      </ul>
    }
    <div class="bottom">
      <ng-content select=".bottom"></ng-content>
    </div>
    <a href="/" class="logo">
      <p>Copenhagen <br/> Sustainability Guide</p>
      <p class="no-bold">by</p>
      @if (infoService.data()) {
        <img [src]="infoService.data().logoPath" width="190" height="54" alt=""/>
      }
    </a>
  </nav>
  <div class="nav-backdrop" (click)="closeMenu()" [ngClass]="{'visible':navBarService.isNavBarVisible()}">
  </div>
}
